import { useGlobalState } from '../store'

const sortCat = (a, b) => {
  if (a.order > b.order) return 1
  if (b.order > a.order) return -1

  return 0
}

const useCategories = () => {
  const [categories] = useGlobalState('categories')

  return {
    categories: categories.list.sort(sortCat),
  }
}

export default useCategories
